// const UserCreate = () => import ('@/components/Admin/User/UserCreate');
const UserEdit = () => import ("@/components/Admin/User/UserEdit");
const UserIndex = () => import("@/components/Admin/User/UserIndex");
const UserView = () => import("@/components/Admin/User/UserView");

const routes = [
  // {
  //   name: 'UserCreate',
  //   path: '/users/create',
  //   component: UserCreate,
  //   meta: {
  //     title: 'Create User',
  //     sidebar: true
  //   }
  // },
  {
    name: "UserIndex",
    path: "/users",
    component: UserIndex,
    meta: {
      title: "Users",
      sidebar: true
    }
  },
  {
    name: "UserView",
    path: "/users/:id",
    component: UserView,
    meta: {
      title: "View user",
      sidebar: true
    }
  },
  {
    name: 'UserEdit',
    path: '/users/:id/edit',
    component: UserEdit,
    meta: {
      title: 'Edit user',
      sidebar: true
    }
  }
];

export default routes;
